export const FEATURE_ENABLE_PROGRAMS = 'ENABLE_PROGRAMS';
export const FEATURE_PROGRAM_TYPE_FACET = 'ENABLE_PROGRAM_TYPE_FACET';
export const FEATURE_EXEC_ED_INCLUSION = 'ENABLE_EXEC_ED_INCLUSION';
export const FEATURE_CONSOLIDATE_SUBS_CATALOG = 'ENABLE_CONSOLIDATE_SUBS_CATALOG';
export const FEATURE_ENABLE_AI_CURATION = 'ENABLE_AI_CURATION';
